import { DEV, TEST, DEBUG_CREATIVE_SUITE_API } from '../constants';

import * as FixturesApi from './creativeSuiteFixturesApi';
import * as StandardApi from './creativeSuiteApi';

// Were ignoring this eslint rule so that we can click through into the StandardApi when exploring the code
// eslint-disable-next-line import/no-mutable-exports
let creativeSuiteApi = StandardApi;
if (TEST || (DEV && DEBUG_CREATIVE_SUITE_API)) {
  creativeSuiteApi = FixturesApi;
}

export default creativeSuiteApi;
